import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row justify-between items-start mb-12">
          <div className="mb-6 lg:mb-0">
            <div className="flex items-center space-x-3 mb-3">
              <img
                src="https://public.readdy.ai/ai/img_res/641cf114-66ad-406c-8c7e-b8b1bf5746b8.png"
                alt="PINTORDECO Barcelona"
                className="h-12 w-auto object-contain"
              />
              <div>
                <h3 className="font-bold text-xl">PINTORDECO</h3>
                <p className="text-sm text-gray-300">Barcelona</p>
              </div>
            </div>
          </div>
          <p className="text-gray-300 max-w-md">
            Pintores profesionales en Barcelona con más de 15 años de experiencia. Calidad, limpieza y puntualidad garantizadas.
          </p>
        </div>

        {/* Navigation Columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Servicios */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Servicios</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/servicios" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Pintura Interior
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Alisado de Gotelé
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Locales Comerciales
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Pintura Exterior
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Solicitar Presupuesto
                </Link>
              </li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Empresa</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/empresa" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link to="/empresa" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Nuestro Equipo
                </Link>
              </li>
              <li>
                <Link to="/empresa" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Cómo Trabajamos
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Preguntas Frecuentes
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-white/80 hover:text-accent transition-colors cursor-pointer">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Ayuda */}
          <div>
            <h4 className="font-bold text-lg mb-4">Ayuda</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-accent transition-colors cursor-pointer">
                  Preguntas frecuentes
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-300 hover:text-accent transition-colors cursor-pointer">
                  Contacto
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-300 hover:text-accent transition-colors cursor-pointer">
                  Solicitar presupuesto
                </Link>
              </li>
            </ul>
          </div>

          {/* Copyright & Social */}
          <div className="text-right">
            <p className="font-serif text-lg mb-2">© PINTORDECO {currentYear}</p>
            <p className="text-gray-300 text-sm mb-4">Todos los derechos reservados</p>
            <div className="flex justify-end space-x-4">
              <a href="#" className="text-gray-300 hover:text-accent transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-accent transition-colors cursor-pointer">
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-accent transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="grid md:grid-cols-3 gap-8 items-center pt-8 border-t border-white/10">
          {/* Image */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/bedc291834b4f864ac2b2a9c387be2cb.jpg"
              alt="Trabajo profesional de pintura"
              className="w-full h-32 object-cover rounded-lg"
            />
          </div>

          {/* Text */}
          <div className="text-center">
            <p className="font-serif text-2xl leading-relaxed">
              Calidad profesional <br />
              <span className="italic text-gray-300">en cada proyecto</span> <br />
              de pintura
            </p>
          </div>

          {/* Newsletter */}
          <div>
            <p className="text-sm text-gray-300 mb-3">
              Recibe consejos y ofertas exclusivas
            </p>
            <form className="flex space-x-2">
              <input
                type="email"
                placeholder="Tu email"
                className="flex-1 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-accent text-sm"
              />
              <button
                type="submit"
                className="whitespace-nowrap px-5 py-2 bg-accent text-white rounded-full hover:bg-accent/90 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Legal Links */}
        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <div className="flex space-x-6">
            <a href="#" className="hover:text-accent transition-colors cursor-pointer">
              Aviso legal
            </a>
            <a href="#" className="hover:text-accent transition-colors cursor-pointer">
              Política de privacidad
            </a>
            <a href="#" className="hover:text-accent transition-colors cursor-pointer">
              Política de cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
